import { useFeatureFlagQuery } from "../../../hooks/useFeatureFlag";
import { useEnhancedAiPanelEnabled } from "./useEnhancedAiPanelEnabled";

export const ASK_CONVERSATION_HISTORY_FEATURE_FLAG = "ff-temp-is-ask-conversation-history-enabled";

/**
 * Whether the Recent Conversations UI is active (PY-13559).
 *
 * Two flags, because they gate different things. The server persists
 * conversations on its own flag so history can be exercised ahead of any UI;
 * this one additionally requires the enhanced panel, since the dropdown hangs
 * off the panel header and the legacy FAB has nowhere to put it.
 */
export const useAskConversationHistoryEnabled = (): boolean => {
	const { value: historyFlagEnabled } = useFeatureFlagQuery(ASK_CONVERSATION_HISTORY_FEATURE_FLAG, false);
	const panelEnabled = useEnhancedAiPanelEnabled();

	return historyFlagEnabled && panelEnabled;
};
